import SvgIcon from "@material-ui/core/SvgIcon";

export const CustomHomeIcon = (props) => {
    return (
        <SvgIcon width="20" height="21" viewBox="0 0 20 21" fill="#CDBDDB" {...props}>
            <path d="M8.33342 17.6244V12.6244H11.6667V17.6244H15.8334V10.9578H18.3334L10.0001 3.45776L1.66675 10.9578H4.16675V17.6244H8.33342Z"/>
        </SvgIcon>
    )
}